import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import volumetria_api from '../../../api/volumetria_api';

//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import { transformValueFloattoFormated } from '../../../helpers/formats';
import mascaras from '../../../helpers/mascaras';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial da volumetria
function initialStateVolumetria() {
    return {
        tbVolumetria_Descricao: "",
        unidade: "Kg",
        capacidade: "0,00",
        status: "Ativo"
    }
}
export default function Volumetria({ permissao }) {
    //Estado que guarada as volumetrias que serão listadas
    const [volumetrias, setVolumetrias] = useState([]);

    //Estado que guarada os dados da volumetria que sera Adicionada/Editada
    const [volumetria, setVolumetria] = useState(initialStateVolumetria);

    //Estado de controle da apresentação do modal
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle de loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros dos campos obritorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "tbVolumetria_Descricao", required: true }),
        objCampo({ name: "capacidade", required: true, number: true }),
        objCampo({ name: "unidade", required: true }),
    ]

    //Troca de estado do modal na tela
    const toggleModal = () => {
        if (openModal) {
            setVolumetria(initialStateVolumetria);
            setErrors({});
        }
        setOpenModal(!openModal);
    };

    //Carrega todas as volmuetrias para a listagem
    const loadVolumetrias = () => {
        setLoading(true);
        volumetria_api.GetList().then(response => {
            response.data = response.data.map(value => {
                value.capacidade = transformValueFloattoFormated(value.capacidade);
                return value;
            })
            setVolumetrias(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega todas as volumetrias assim que o componente é iniciado
    useEffect(() => {
        loadVolumetrias();
    }, []);

    //Change dos campos de volumetria
    const onChangeVolumetria = (e) => {
        const { name, value } = e.target;

        const _volumetria = {
            ...volumetria,
            [name]: value
        }
        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_volumetria, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setVolumetria(_volumetria);
    }

    //Adiciona/Edita uma volumetria
    const addNovaVolumetria = () => {
        const erros = validarCampos(volumetria, campos);
        const _volumetria = { ...volumetria };
        _volumetria.capacidade = parseFloat(_volumetria.capacidade.replace(",", ".")).toFixed(2);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        }
        setLoading(true);
        if (volumetria.id) {
            volumetria_api.Put(_volumetria).then(response => {
                loadVolumetrias();
                setVolumetria(initialStateVolumetria);
                toggleModal();
                showMessage("Sucesso", "Volumetria atualizada com sucesso!", "success");
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        } else {
            volumetria_api.Post(_volumetria).then(response => {
                loadVolumetrias();
                setVolumetria(initialStateVolumetria);
                toggleModal();
                showMessage("Sucesso", "Volumetria criada com sucesso!", "success");
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //Cabeçalhos da tabela de volumetrias
    const headers = [
        { value: "Identificação", objectValue: "tbVolumetria_Descricao", align: "left" },
        { value: "Unidade", objectValue: "unidade", align: "left" },
        { value: "Capacidade", objectValue: "capacidade", align: "right" },
        { value: "Status", objectValue: "status", align: "left" },
    ]

    //Armazena os dados para edição de uma volumetria
    const editarVolumetria = (item, itemKey) => {

        setVolumetria(item);
        volumetria_api.GetItem(item.id).then(response => {
            response.data.capacidade = parseFloat(response.data.capacidade).toFixed(2).toString().replace(".", ",");
            setVolumetria(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
        toggleModal();
    }

    //Variavel que guarda as açoes da tabela
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editarVolumetria));
    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized title={volumetria.id ? <><FontAwesomeIcon icon={faEdit} /> Editar volumetria</> : "Nova volumetria"} isOpen={openModal} toggle={toggleModal} btnAction={volumetria.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} btnActionColor={volumetria.id ? "warning text-light" : "success"} onClickBtnAction={addNovaVolumetria} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.tbVolumetria_Descricao ? true : false} maxLength={"100"} label={"* Identificação"} name={"tbVolumetria_Descricao"} onChange={onChangeVolumetria} value={volumetria.tbVolumetria_Descricao} />
                            <PrintValidate errors={errors} field={"tbVolumetria_Descricao"} />
                        </Col>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.status ? true : false} label={"Status"} type={"select"} options={[{ text: "Ativo", value: "Ativo" }, { text: "Inativo", value: "Inativo" }]} name={"status"} onChange={onChangeVolumetria} value={volumetria.status} />
                            <PrintValidate errors={errors} field={"status"} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField mask={mascaras.floatMask} inputClassName={"textRight"} invalid={errors.capacidade ? true : false} label={"* Capacidade"} name={"capacidade"} onChange={onChangeVolumetria} value={volumetria.capacidade} />
                            <PrintValidate errors={errors} field={"capacidade"} />
                        </Col>
                        <Col md="12" lg="6">
                            <TextField
                                invalid={errors.unidade ? true : false}
                                maxLength={"50"}
                                label={"* Unidade"}
                                type={"select"}
                                options={[
                                    { text: "Kg", value: "Kg" }, 
                                    { text: "L", value: "L" }, 
                                    { text: "m2", value: "m2" }, 
                                    { text: "m3", value: "m3" }, 
                                    { text: "UN", value: "UN" }
                                ]}
                                name={"unidade"}
                                onChange={onChangeVolumetria}
                                value={volumetria.unidade}
                            />
                            <PrintValidate errors={errors} field={"unidade"} />
                        </Col>

                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de volumetrias"} options={{ print: false, search: true, pagination: true }} headers={headers} items={volumetrias} />
                </div>
            </MainCard>
        </>
    )
}